import { AxiosResponse } from 'axios';
import { get, post } from 'services/api';
import { IUpdateSystemStatusPayload } from 'types/systemStatus.types';

export const getSystemStatus = (): Promise<AxiosResponse> => get('system-status');

export const updateSystemStatus = (data: IUpdateSystemStatusPayload): Promise<AxiosResponse> =>
  post('system-status', data);
